/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentForm } from './PaymentForm';
import {
    PaymentFormFromJSON,
    PaymentFormFromJSONTyped,
    PaymentFormToJSON,
} from './PaymentForm';

/**
 * 
 * @export
 * @interface CreatePaymentFormOutput
 */
export interface CreatePaymentFormOutput {
    /**
     * 
     * @type {PaymentForm}
     * @memberof CreatePaymentFormOutput
     */
    form?: PaymentForm;
    /**
     * 
     * @type {Error}
     * @memberof CreatePaymentFormOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the CreatePaymentFormOutput interface.
 */
export function instanceOfCreatePaymentFormOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreatePaymentFormOutputFromJSON(json: any): CreatePaymentFormOutput {
    return CreatePaymentFormOutputFromJSONTyped(json, false);
}

export function CreatePaymentFormOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentFormOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form': !exists(json, 'form') ? undefined : PaymentFormFromJSON(json['form']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function CreatePaymentFormOutputToJSON(value?: CreatePaymentFormOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form': PaymentFormToJSON(value.form),
        'error': value.error,
    };
}

